import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveView from '../views/ResponsiveView';


import Radium from 'radium';



import { withTranslation } from 'react-i18next';


class SpotifyTrack extends ResponsiveView {

  constructor(props) {
    super(props, true);

    this.state = {
      spotifyTrack: null
    };

  }

  onViewResize() {
    return true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.spotifyTrack !== this.props.spotifyTrack) {
      console.log('SpotifyTrack updated', this.props.spotifyTrack);
      // optionally set internal state if needed
      this.setState({}); // forces re-render if ResponsiveView blocks updates
    }
  }

  toggleNavigationDisplay(newButtonState) {
    console.log("toggleNavigationDisplay ", newButtonState);
    this.setState({
      isMenuVisible: newButtonState,
    })
  }

  render() {
    //const { t, spotifyTrack } = this.props;
    console.log("SpotifyTrack render ", this.props.spotifyTrack);


    if (!this.props.spotifyTrack) {
      return null; // or a loading indicator
    }

    return (
      <div style={this.styles().container}>


        <a target="_blank" href={this.props.spotifyTrack.external_urls.spotify} rel="noopener noreferrer" >
          Listen on Spotify:
          <br />
          <img src={this.props.spotifyTrack.album.images[0].url}
            alt={this.props.spotifyTrack.album.name}
            style={{ maxWidth: '200px', height: 'auto' }}
          ></img>
        </a>




      </div>
    );
  }

  styles() {

    return {

      container: {
        marginTop: '6px',
        marginBottom: '6px',
      },



    }

  }
}

SpotifyTrack.propTypes = {
  spotifyTrack: PropTypes.object,
};

export default withTranslation()(Radium(SpotifyTrack));